// import { Button as AntButton } from 'antd';
// import React from 'react';
// import './assets/ButtonStyle.css';

// export const Button = ({ ...props }) => {
//   return (
//     <AntButton className={'createBtn'} {...props}>
//       {props.children}
//     </AntButton>
//   );
// };

// Button.displayName = 'Button';

import { Button as AntButton } from 'antd';
import React from 'react';
import './assets/ButtonStyle.css';

export const Button = ({ className = '', ...props }) => {
  const buttonClassName = className.trim() ? `createBtn ${className}` : 'createBtn';
  return (
    <AntButton className={buttonClassName} {...props}>
      {props.children}
    </AntButton>
  );
};

Button.displayName = 'Button';
